import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from '../../service/loader.service';
import { Message } from '../../service/message.service';
import { RestService } from '../../service/rest.service';

@Component({
  selector: 'app-join',
  templateUrl: './join.component.html',
  styles: [],
  standalone: false
})
export class JoinComponent implements OnInit {
  hover = -1

  constructor(private router: Router,private rest:RestService,private message:Message,private loader:LoaderService) {

  }

    myFormData = new FormData() 

  ngOnInit(): void { }

  goToContact() {
    window.location.replace('contatti')
  }

  openInput(){
    let input = document.getElementById('upload-cv')
    input?.click()
  }

  changeInput(event:any){
    if(event.target.files[0]){
      this.loader.on()
      this.myFormData.append('file',event.target.files[0])
      this.rest.post('/user/curriculum',this.myFormData).subscribe({
        next:(value)=> {
          this.loader.off(false)
          this.message.showMessage('Curriculum caricato con successo','success')
        },
        error:(value)=> {
          this.loader.off(false)
          this.message.showMessage('Errore nel caricamento del file','error')
        },
      })
    }
  }
}
